const mapToObj = (inputMap) => {
  let obj = {};
  inputMap.forEach(function (value, key) {
    obj[key] = value;
  });
  return obj;
}

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return mapToObj(map);
}